var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-lg-poll_svg__clip0_2600_44875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 1,
    width: 21,
    height: 13,
    rx: 1,
    fill: "#A8FFF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 4,
    height: 15.797,
    rx: 1,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 4,
    height: 11.797,
    rx: 1,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M17 8h18v12H17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 5.23c.23 0 .417.194.417.433v13.506a.425.425 0 01-.417.433H22a.425.425 0 01-.417-.433V5.663c0-.24.187-.433.417-.433h16zM22.417 18.736h15.166V6.096H22.418v12.64z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.583 4.797c.23 0 .417.194.417.433s-.187.433-.417.433H20.417A.425.425 0 0120 5.23c0-.24.186-.433.417-.433h19.166zM26.833 16.658c0 .24-.186.433-.416.433a.425.425 0 01-.417-.433V12.33c0-.239.186-.433.417-.433.23 0 .416.194.416.433v4.33zM29.833 16.658c0 .24-.186.433-.416.433a.425.425 0 01-.417-.433V8.173c0-.239.186-.432.417-.432.23 0 .416.193.416.432v8.485zM30.325 19.439l-4 5.195a.406.406 0 01-.585.068.445.445 0 01-.065-.609l4-5.194a.406.406 0 01.585-.068c.18.15.209.421.065.608z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.675 19.439l4 5.195a.406.406 0 00.585.068.445.445 0 00.065-.609l-4-5.194a.406.406 0 00-.585-.068.444.444 0 00-.065.608zM32.833 16.659a.425.425 0 01-.416.433.425.425 0 01-.417-.433V10.25c0-.239.187-.433.417-.433.23 0 .416.194.416.433v6.408z",
    fill: "#14454C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-lg-poll_svg__clip0_2600_44875"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15)",
    d: "M0 0h30v30H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-lg-poll-ec06905d6c167eb9003002206092aca7.svg";
export { SvgAiLgPoll as ReactComponent };